import React from "react";
import images from "../../../images";
// import { calculateDays } from "../../../Utils/helper";
import { getTimeStatus } from "../../../Utils/helper";

import { useTranslation } from "react-i18next";

const QuestCard = ({
  name,
  status,
  responses,
  totalResponses,
  endTime,
  isCompleted,
  handleView,
  handleToPerforman,
  handleTaskQuest,
  handleQRCode,
  statusText,
}) => {
  const { t } = useTranslation();

  const statusConfig = {
    DRAFT: {
      text: t("quest.status.draft"),
      color: "bg-gray-400",
    },
    PUBLISHED: {
      text: t("quest.status.published"),
      color: "bg-amber-400",
    },
    IN_PROGRESS: {
      text: t("quest.status.inProgress"),
      color: "bg-amber-400",
    },
    COMPLETED: {
      text: t("quest.status.completed"),
      color: "bg-teal-500",
    },
    ARCHIVED: {
      text: t("quest.status.archived"),
      color: "bg-purple-500",
    },
  };
  const statusColor = isCompleted ? "bg-teal-500" : "bg-amber-400";
  const timeIcon = isCompleted
    ? images.ClockCircleIcon
    : images.ClockCircleIcon;

  const { days, isPast, isSameDay } = getTimeStatus(endTime);
  const daysNum = parseInt(days);

  const expireTime = (() => {
    if (isPast) {
      if (isSameDay || daysNum === 0) {
        return t("quest.time.today");
      }
      return t("quest.time.ended", { count: daysNum, days });
    } else {
      if (isSameDay || daysNum === 0) {
        return t("quest.time.today");
      }
      return t("quest.time.endsIn", { count: daysNum, days });
    }
  })();
  const currentStatus = statusConfig[statusText] || statusConfig.PUBLISHED;
  return (
    <div className="flex flex-col justify-center p-2.5 w-full bg-white rounded-xl border border-solid border-stone-200 mt-4">
      <div className="flex gap-4 justify-between items-start w-full">
        <div className="flex gap-1.5 items-start self-stretch my-auto ">
          {/* <div className="flex gap-2.5 justify-center items-center self-stretch pr-2.5 my-auto w-8 h-8 rounded-xl bg-blue-100 bg-opacity-60 min-h-[32px]"> */}
          <img
            loading="lazy"
            src={images.QuestTaskIcon}
            alt=""
            className="object-contain self-stretch my-auto aspect-[1.83] w-[44px]"
          />
          {/* </div> */}
          <div className="self-stretch my-auto text-lg font-semibold rounded-none text-zinc-800 ">
            {name}
          </div>
        </div>
        <div
          className={`gap-2.5  px-2.5 py-1 text-xs font-medium leading-none whitespace-nowrap ${currentStatus.color}  rounded-md  text-neutral-50 `}
        >
          {currentStatus.text}
        </div>
      </div>
      <div className="flex flex-col justify-center mt-3 w-full">
        <div className="flex gap-1 items-center w-full">
          <div className="flex gap-1.5 items-center self-stretch my-auto">
            <div className="self-stretch my-auto text-sm font-bold leading-relaxed text-neutral-500">
              <span className="text-zinc-800">{responses}</span>
              <span className="">/{totalResponses}</span>
            </div>
            <div className="self-stretch my-auto text-xs font-medium text-zinc-800">
              {t("base.responses")}
            </div>
          </div>
        </div>
        <div className="flex flex-col mt-1 w-full rounded-2xl">
          <div
            className={`flex flex-col items-start rounded-2xl ${
              isCompleted ? "bg-teal-500" : "bg-stone-200"
            }`}
          >
            <div
              className={`flex shrink-0 h-1 ${statusColor} rounded-2xl`}
              style={{
                width: `${
                  totalResponses > 0
                    ? Math.min((responses / totalResponses) * 100, 100)
                    : 0
                }%`,
              }}
            />
          </div>
        </div>
      </div>
      <div className="flex gap-10 justify-between items-center mt-3 w-full text-xs min-h-[36px]">
        <div className="flex gap-1 items-center self-stretch my-auto text-neutral-500">
          <img
            loading="lazy"
            src={timeIcon}
            alt=""
            className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
          />
          <div className="self-stretch my-auto">{expireTime}</div>
        </div>
        {isCompleted ? (
          <div className="flex gap-2.5 items-center self-stretch my-auto">
            {/* <div
              onClick={handleQRCode}
              className="flex overflow-hidden gap-1.5 justify-center items-center self-stretch px-1 my-auto w-9 rounded-xl  min-h-[36px]"
            >
              <img
                loading="lazy"
                src={images.QRCodeIcon}
                alt=""
                className="object-contain self-stretch my-auto aspect-square w-[30px]"
              />
            </div> */}
            <div
              onClick={handleTaskQuest}
              className="flex overflow-hidden gap-1.5 justify-center items-center self-stretch px-1 my-auto w-9 rounded-xl  min-h-[36px]"
            >
              <img
                loading="lazy"
                src={images.ListGroupIcon}
                alt=""
                className="object-contain self-stretch my-auto aspect-square w-[30px]"
              />
            </div>
            <div
              onClick={handleToPerforman}
              className="flex overflow-hidden gap-1.5 justify-center items-center self-stretch px-1 my-auto w-9 rounded-xl  min-h-[36px]"
            >
              <img
                loading="lazy"
                src={images.ChartIcon}
                alt=""
                className="object-contain self-stretch my-auto aspect-square w-[30px]"
              />
            </div>
          </div>
        ) : (
          // <div
          //   onClick={handleView}
          //   className="flex overflow-hidden gap-0.5 justify-center items-center self-stretch pr-1.5 pl-3 my-auto font-medium text-indigo-600 whitespace-nowrap rounded-xl border border-solid border-stone-200 min-h-[36px]"
          // >
          <>
            <div className="flex gap-1">
              <div
                onClick={handleQRCode}
                className="flex overflow-hidden gap-1.5 justify-center items-center self-stretch px-1 my-auto w-9 rounded-xl  min-h-[36px]"
              >
                <img
                  loading="lazy"
                  src={images.QRCodeIcon}
                  alt=""
                  className="object-contain self-stretch my-auto aspect-square w-[30px]"
                />
              </div>
              <div
                onClick={handleView}
                className="flex overflow-hidden gap-1.5 justify-center items-center self-stretch px-1 my-auto w-9 rounded-xl  min-h-[36px]"
              >
                <img
                  loading="lazy"
                  src={images.ListGroupIcon}
                  alt=""
                  className="object-contain self-stretch my-auto aspect-square w-[30px]"
                />
              </div>
            </div>
          </>
          // </div>
        )}
      </div>
    </div>
  );
};

export default QuestCard;
